import {useState} from 'react'
import {useParams, useNavigate} from 'react-router-dom'

import Style from './style'

import leftBlack from './asset/left_black.svg'
import leftGrey from './asset/left_grey.svg'
import rightBlack from './asset/right_black.svg'
import rightGrey from './asset/right_grey.svg'
import GiveModal from './ui/GiveModal'

import MainHeader from 'widget/MainHeader'

import useGetSeriesDetail from 'entity/series/useGetSeriesDetail'
import useDeleteSeries from 'entity/series/useDeleteSeries'

import TStyle from 'shared/style/tableStyle'
import DTStyle from 'shared/style/detailTableStyle'
import timestampCalculator from 'shared/lib/timestampCalculator'
import useConfirmModalAtom from 'shared/model/useConfirmModalAtom'
import {convertProGradeAsName} from 'shared/constant/lookup/proGrade'
import {convertEventStateAsName} from 'shared/constant/lookup/eventState'
import TableLoading from 'shared/ui/TableLoading'

const SeriesDetail = () => {
	const navigate = useNavigate()
	const {idx} = useParams()

	const [isGiveModalOpen, setIsGiveModalOpen] = useState(false)
	const [imgIndex, setImgIndex] = useState(0)

	const [seriesData, isLoading] = useGetSeriesDetail()
	const [deleteSeries] = useDeleteSeries()

	const [, setModalEvent] = useConfirmModalAtom()

	const btnList = [
		{
			label: '수정',
			clickEvent: () => navigate(`/series/${idx}/edit`),
		},
		{
			label: '삭제',
			clickEvent: () =>
				setModalEvent(
					'현재 발행된 시드권과 참가권의 사용이 불가해집니다.\n정말 삭제하시겠습니까?',
					() => deleteSeries
				),
		},
		{
			label: '시드권 지급',
			clickEvent: () => setIsGiveModalOpen(true),
		},
	]

	const seriesDataList = [
		{
			label: 'IDX',
			value: seriesData?.data?.series?.idx,
		},
		{
			label: '대회 시리즈 이름',
			value: seriesData?.data?.series?.name,
		},
		{
			label: '시작 날짜',
			value: timestampCalculator(seriesData?.data?.series?.start_date, 'date'),
		},
		{
			label: '종료 날짜',
			value: timestampCalculator(seriesData?.data?.series?.end_date, 'date'),
		},
		{
			label: '전체 GTD',
			value: seriesData?.data?.series?.total_gtd || '-',
		},
		{
			label: '메인 이벤트 GTD',
			value: seriesData?.data?.series?.main_gtd || '-',
		},
		{
			label: '생성 날짜',
			value: timestampCalculator(seriesData?.data?.series?.created_at),
		},
	]
	const seriesContentData = seriesData?.data?.series?.content
	const seriesLogoImg = seriesData?.data?.series?.logo_img
	const seriesImgList = seriesData?.data?.series?.img_list
	const seedTicketList = seriesData?.data?.seed_ticket_type

	const officialSizeList = [
		'short',
		'expand',
		'long',
		'medium',
		'medium',
		'medium',
		'medium',
		'long',
	]
	const officialHeadList = [
		'IDX',
		'대회 이름',
		'대회 날짜',
		'요구 프로 자격',
		'상태',
		'시드권 종류',
		'필요 개수',
		'생성 날짜',
	]
	const officialDataList = seriesData?.data?.official_event

	const preliminarySizeList = [
		'short',
		'expand',
		'long',
		'medium',
		'medium',
		'expand',
		'long',
	]
	const preliminaryHeadList = [
		'IDX',
		'대회 이름',
		'대회 날짜',
		'요구 프로 자격',
		'상태',
		'대회 주소지',
		'생성 날짜',
	]
	const preliminaryDataList = seriesData?.data?.preliminary_event

	return (
		<>
			{isGiveModalOpen && (
				<GiveModal
					seriesIdx={idx}
					closeEvent={() => setIsGiveModalOpen(false)}
				/>
			)}

			<Style.Wrapper>
				<MainHeader btnList={btnList} />

				<Style.AreaDiv>
					<h2>대회 시리즈 데이터</h2>
					<DTStyle.TableDiv>
						{seriesDataList?.map((elem, index) => (
							<DTStyle.TableElement key={index}>
								<h2>{elem?.label}</h2>
								<p>{elem?.value}</p>
							</DTStyle.TableElement>
						))}
					</DTStyle.TableDiv>
				</Style.AreaDiv>

				<Style.AreaDiv>
					<h2>내용</h2>
					<DTStyle.TableDiv>
						<DTStyle.TableElement>
							<h2>본문</h2>
							<p>{seriesContentData}</p>
						</DTStyle.TableElement>
					</DTStyle.TableDiv>
				</Style.AreaDiv>

				{seriesLogoImg && (
					<Style.AreaDiv>
						<h2>로고 이미지</h2>
						<div>
							<Style.ContentImg src={seriesLogoImg} />
						</div>
					</Style.AreaDiv>
				)}

				{seriesImgList?.length > 0 && (
					<Style.AreaDiv>
						<h2>첨부된 이미지</h2>
						<Style.SliderDiv>
							<button
								onClick={() =>
									setImgIndex((state) => (state > 0 ? state - 1 : state))
								}
							>
								<img src={imgIndex === 0 ? leftGrey : leftBlack} />
							</button>
							<button
								onClick={() =>
									setImgIndex((state) =>
										state < seriesImgList?.length - 1 ? state + 1 : state
									)
								}
							>
								<img
									src={
										imgIndex === seriesImgList?.length - 1
											? rightGrey
											: rightBlack
									}
								/>
							</button>
						</Style.SliderDiv>
						<Style.ContentImg src={seriesImgList[imgIndex]} />
					</Style.AreaDiv>
				)}

				<Style.AreaDiv>
					<h2>시드권 종류</h2>
					<DTStyle.TableDiv>
						{seedTicketList?.map((elem, index) => (
							<DTStyle.TableVerticalElement key={index}>
								<h2>{index + 1}</h2>
								<p>{elem?.name}</p>
							</DTStyle.TableVerticalElement>
						))}
					</DTStyle.TableDiv>
				</Style.AreaDiv>

				<Style.AreaDiv>
					<h2>포함된 공식 대회 목록</h2>
					<TableLoading isLoading={isLoading}>
						<TStyle.TableDiv>
							<TStyle.TableInner>
								<TStyle.TableRow $title>
									{officialHeadList.map((elem, index) => (
										<TStyle.Data
											key={index}
											$title
											$size={officialSizeList[index]}
										>
											{elem}
										</TStyle.Data>
									))}
								</TStyle.TableRow>
								{officialDataList?.map((elem, index) => (
									<TStyle.TableRow
										key={index}
										$odd={index % 2 === 1}
										onClick={() => navigate(`/event/${elem?.idx}/detail`)}
									>
										<TStyle.Data $size={officialSizeList[0]}>
											{elem?.idx}
										</TStyle.Data>
										<TStyle.Data $size={officialSizeList[1]}>
											{elem?.name}
										</TStyle.Data>
										<TStyle.Data $size={officialSizeList[2]}>
											{timestampCalculator(elem?.date)}
										</TStyle.Data>
										<TStyle.Data $size={officialSizeList[3]}>
											{convertProGradeAsName[elem?.pro_grade_flag]}
										</TStyle.Data>
										<TStyle.Data $size={officialSizeList[4]}>
											{convertEventStateAsName[elem?.event_state_flag]}
										</TStyle.Data>
										<TStyle.Data $size={officialSizeList[5]}>
											{elem?.seed_ticket}
										</TStyle.Data>
										<TStyle.Data $size={officialSizeList[6]}>
											{elem?.ticket_number}
										</TStyle.Data>
										<TStyle.Data $size={officialSizeList[7]}>
											{timestampCalculator(elem?.created_at)}
										</TStyle.Data>
									</TStyle.TableRow>
								))}
							</TStyle.TableInner>
						</TStyle.TableDiv>
					</TableLoading>
				</Style.AreaDiv>

				<Style.AreaDiv>
					<h2>포함된 공식 예선전 목록</h2>
					<TableLoading isLoading={isLoading}>
						<TStyle.TableDiv>
							<TStyle.TableInner>
								<TStyle.TableRow $title>
									{preliminaryHeadList.map((elem, index) => (
										<TStyle.Data
											key={index}
											$title
											$size={preliminarySizeList[index]}
										>
											{elem}
										</TStyle.Data>
									))}
								</TStyle.TableRow>
								{preliminaryDataList?.map((elem, index) => (
									<TStyle.TableRow
										key={index}
										$odd={index % 2 === 1}
										onClick={() => navigate(`/event/${elem?.idx}/detail`)}
									>
										<TStyle.Data $size={preliminarySizeList[0]}>
											{elem?.idx}
										</TStyle.Data>
										<TStyle.Data $size={preliminarySizeList[1]}>
											{elem?.name}
										</TStyle.Data>
										<TStyle.Data $size={preliminarySizeList[2]}>
											{timestampCalculator(elem?.date)}
										</TStyle.Data>
										<TStyle.Data $size={preliminarySizeList[3]}>
											{convertProGradeAsName[elem?.pro_grade_flag]}
										</TStyle.Data>
										<TStyle.Data $size={preliminarySizeList[4]}>
											{convertEventStateAsName[elem?.event_state_flag]}
										</TStyle.Data>
										<TStyle.Data $size={preliminarySizeList[5]}>
											{elem?.address}
										</TStyle.Data>
										<TStyle.Data $size={preliminarySizeList[7]}>
											{timestampCalculator(elem?.created_at)}
										</TStyle.Data>
									</TStyle.TableRow>
								))}
							</TStyle.TableInner>
						</TStyle.TableDiv>
					</TableLoading>
				</Style.AreaDiv>

				{/* <Style.AreaDiv>
                <h2>시드권 보유 사용자 목록</h2>

            </Style.AreaDiv> */}
			</Style.Wrapper>
		</>
	)
}

export default SeriesDetail
